import BaseComponentController from '../../../../components/base-component.controller';

class SecondaryEmploymentQuestionController extends BaseComponentController {
    constructor(_, componentRegistryService, $q, constants) {
        super(_, componentRegistryService, $q);
        this.vm = {
            errors:[]
        };
        this.consultancyLink = constants.Links.Consultancy;
    }

    init() {
        this.vm = {
            errors:[]
        };
        if (this._.isEmpty(this.model)) {
            this.model = {
                selectedOption: null
            };
        }
    }

    validate() {
        if (this.readonly) {
            return true;
        }

       if (this._.isEmpty(this.model.selectedOption)) {
            this.vm.errors= [`Please select an employment option`];
        } else {
            this.vm.errors = [];
       }
       return this.vm.errors.length === 0;
    }

    validateAsync() {
        return this.getPromise(this.validate());
    }
    
    employmentOptionSelected() {
        this.vm = {
            errors:[]
        };
    }
}

SecondaryEmploymentQuestionController.$inject = ['_', 'componentRegistryService', '$q', 'constants'];

let secondaryEmploymentQuestionComponent = {
    controller: SecondaryEmploymentQuestionController,
	bindings: {
	    employmentOptions: '<',
	    readonly: '<',
	    modelName:'@'
	},
	templateUrl:`app/disclose/conflictOfInterest/components/secondary-emp-ques/secondary-emp-ques.html`
};

export default secondaryEmploymentQuestionComponent;


// WEBPACK FOOTER //
// ./app/disclose/conflictOfInterest/components/secondary-emp-ques/secondary-emp-ques.component.js